angular.module('app.directives').directive('appRickshaw', function($compile, $window) {
    'ngInject';

    const originalBarWidth = Rickshaw.Graph.Renderer.Bar.prototype.barWidth;

    return {
        restrict: 'EA',
        scope: {
            options: '=rickshawOptions',
            series: '=rickshawSeries',
            features: '=rickshawFeatures'
        },

        link(scope, element, attrs) {
            let graph = null;

            const getSettings = function(el) {
                const settings = angular.copy(scope.options);
                settings.element = el;
                settings.series = scope.series;
                return settings;
            };

            const update = function() {
                const mainEl = angular.element(element);
                const graphEl = $compile('<div></div>')(scope);
                // Fix the height (if specified in the options) so that replacing the html contents won't
                // monkey with the page scrolling
                if (scope.options.height != null) {
                    $(graphEl[0]).css('height', `${scope.options.height}px`);
                }
                mainEl.html(graphEl);
                const settings = getSettings(graphEl[0]);
                graph = new Rickshaw.Graph(settings);

                if (scope.features && scope.features.hover) {
                    const hoverConfig = { graph };
                    hoverConfig.xFormatter = scope.features.hover.xFormatter;
                    hoverConfig.yFormatter = scope.features.hover.yFormatter;
                    hoverConfig.formatter = scope.features.hover.formatter;
                    const hoverDetail = new Rickshaw.Graph.HoverDetail(hoverConfig);
                }

                if (scope.features && scope.features.palette) {
                    const palette = new Rickshaw.Color.Palette({ scheme: scope.features.palette });
                    for (let series of Array.from(settings.series)) { series.color = palette.color(); }
                }

                if ((scope.options && scope.options.renderer === 'bar') && (scope.features && (scope.features.minimum_bar_width || scope.features.maximum_bar_width))) {
                    const min = scope.features.minimum_bar_width || 0;
                    let max = scope.features.maximum_bar_width || 999999;
                    if (max < min) { max = min; }
                    Rickshaw.Graph.Renderer.Bar.prototype.barWidth = function(series) {
                        const orig = originalBarWidth.apply(graph.renderer, [series]);
                        return Math.min(Math.max(orig, min), max);
                    };
                }

                graph.render();

                if (scope.features && scope.features.xAxis) {
                    const xAxisConfig = { graph };
                    if (scope.features.xAxis.timeUnit) {
                        const time = new Rickshaw.Fixtures.Time.Local();
                        xAxisConfig.timeUnit = time.unit(scope.features.xAxis.timeUnit);
                    }
                    const xAxis = new Rickshaw.Graph.Axis.Time(xAxisConfig);
                    xAxis.render();
                }

                if (scope.features && scope.features.yAxis) {
                    const yAxisConfig = { graph };
                    if (scope.features.yAxis.tickFormat) {
                        yAxisConfig.tickFormat = Rickshaw.Fixtures.Number[scope.features.yAxis.tickFormat];
                    }
                    const yAxis = new Rickshaw.Graph.Axis.Y(yAxisConfig);
                    yAxis.render();
                }

                if (scope.features && scope.features.legend) {
                    const legendEl = $compile('<div></div>')(scope);
                    mainEl.append(legendEl);

                    const legend = new Rickshaw.Graph.Legend({ graph, element: legendEl[0] });
                    if (scope.features.legend.toggle) {
                        const shelving = new Rickshaw.Graph.Behavior.Series.Toggle({ graph, legend });
                    }
                    if (scope.features.legend.highlight) {
                        const highlighter = new Rickshaw.Graph.Behavior.Series.Highlight({ graph, legend });
                    }
                }

                if (scope.features && scope.features.annotate) {
                    const annEl = $compile('<div></div>')(scope);
                    mainEl.append(annEl);
                    const annotator = new Rickshaw.Graph.Annotate({ graph, element: annEl.get(0) });
                    _.each(scope.features.annotate, a => annotator.add(a.x, a.label));
                    return annotator.update();
                }
            };

            const optionsWatch = scope.$watch('options', function(newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) { return update(); }
            }, true);

            const seriesWatch = scope.$watch(function(scope) {
                    let series;
                    if (scope.features && scope.features.directive && scope.features.directive.watchAllSeries) {
                        const watches = {};
                        for (let i = 0; i < scope.series.length; i++) {
                            series = scope.series[i];
                            watches[`series${i}`] = series.data;
                        }
                        return watches;
                    } else {
                        return scope.series[0].data;
                    }
                },

                function(newValue, oldValue) {
                    if (!angular.equals(newValue, oldValue)) { return update(); }
                }, true);

            const featuresWatch = scope.$watch('features', function(newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) { return update(); }
            });

            /*
            angular.element($window).bind('resize', () => {
              if (graph) {
                graph.configure({width: element.find('div').width()});
              }
            });
            */

            scope.$on('$destroy', function() {
                optionsWatch();
                seriesWatch();
                return featuresWatch();
            });

            return update();
        }
    };
});


// WEBPACK FOOTER //
// ./directives/rickshaw.js